import React, { useState, useEffect, useContext } from "react";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {  FormHelperText } from "@mui/material";
import "../../css/templateForm.scss";
import { cloneTemplateApi, getMarketDetails, getPromomatsId, getSharedFileFromTemp, verifyDeckName } from "../../services/apis";
import CircularProgressBar from "../../utils/CircularProgressBar";
import ValueContext from "../../utils/contextAPI/contextAPI";
import { eDetail, template } from "../../utils/constants";
import CommonAutocompleteDropdown from "../ResuableComponent/CustomModal/DropdownWithFilter/CommonAutocompleteDropdown";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";
import { convertInDate } from "../../utils";
import WarningIcon from "../../images/InfoIconGray.svg";
import CustomTooltip from "../Tooltip/Tooltip";



export default function CloneTemplate(props) {
  const {
    setOpenCloneTemplate,
    openCloneTemplate,
    closeCloneTemplateModal,
    cloneTempdata,
    getEdetailList,
    brands,
    //market,
    campaign,
    createEdetail,
    setIsOpenSharedModal,
    setDeckIdCurrent,
    marketDataListFetch
  } = props;
  let navigate = useNavigate();
  const [market, setMarket] = useState([]);
  const [marketDataList, setMarketDataList] = useState([]);
  const appData = useContext(ValueContext);
  const [isloading, setIsloading] = useState(false);
  const [compaignData, setCampaignData] = useState([]);
  const [helperText, setHelperText] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);
  const [localSharedToggle,setLocalSharedToggle]=useState(true);
  const [isShared, setIsShared] = useState(false);
  const [cloneTempFields, setCloneTempFields] = useState({
    name: '',//cloneTempdata[0].name,
    brand: cloneTempdata[0].brand,
    market: cloneTempdata[0].market,
    campaign: cloneTempdata[0].campaign,
    device: cloneTempdata[0].device,
    dimension: cloneTempdata[0].dimension,
    docNumber:''
  });
  const [PromoMatsID, setPromomatsId] = useState([]);
    const [userName, setUserName] = useState("");
  const [disableBtn, setDisableBtn] = useState(true)
  
  const iconComponent = () => {
    return (
      <ExpandMoreIcon
        style={{
          height: "15.9px",
          color: "#66676b",
          marginRight: "7px",
        }}
      />
    );
  };
  useEffect(() => {
    fetchMarket();
    getAllPromoMatsId();
    let nameObj = localStorage.getItem("currentUserName");
    setUserName(nameObj);
  }, []);

  
  const fontsLength = cloneTempdata[0].deck_shared_assets?.fonts?.length || 0;
  const thumbLength = cloneTempdata[0].deck_shared_assets?.thumb?.length || 0;
  const imagesLength = cloneTempdata[0].deck_shared_assets?.images?.length || 0;
  
  const shouldDisableCheckbox = fontsLength > 0 || thumbLength > 0 || imagesLength > 0;
  const [isChecked, setIsChecked] = useState(false);
  const [enablePinchToZoom, setEnablePinchToZoom] = useState(false);

  const handleCheckboxChange = () => {
    // if (!shouldDisableCheckbox) {
      setIsChecked(!isChecked);
    // }
  };

  const handleChangeCloneTemplates = (e, type) => {
    const name = e.target.name;
    let tempSelected = { ...cloneTempFields };
    tempSelected[name] = e.target.value;
    if (e.target.value.length > 30) {
      setHelperText('Template name exceeded the maximum length')
      setDisableBtn(true)
      setErrorMsg(true)
      //showErrorToast('Template name exceeded the maximum length');
      return;
    }
    if (type === "name") {
      const specialChars = /[`!@#$%^&*+\=\[\]{};':"\\|,.<>\/?~]/;
      if (specialChars.test(e.target.value) || e.target.value.includes(" ")){
        // setHelperText("Name can only contain alphanumeric characters, hyphens (-), and underscores (_).");
        setDisableBtn(true)
        // setErrorMsg(true)
        return;
      }
      if (e.target.value.trim().length < 3) {
        setHelperText("Please use minimum 3 characters")
        setDisableBtn(true)
        setErrorMsg(true)
        setCloneTempFields({
          ...cloneTempFields,
          name: e.target.value,
        });
        return;
      }else if (e.target.value.trim().toLowerCase() === "shared") {
        setHelperText(`"shared" is a reserved name and cannot be used.`);
        setDisableBtn(true);
        setErrorMsg(true);
        setCloneTempFields({
          ...cloneTempFields,
          name: e.target.value,
        });
        return;
      } else {
        setHelperText("");
      }
    }
    setCloneTempFields({
      ...cloneTempFields,
      name: e.target.value,
    });
    if (type === "campaign") {
      setCloneTempFields({
        ...cloneTempFields,
        campaign: e.target.value,
      });
    }
    if (type === "device") {
      tempSelected.device = {
        name: e.target.value,
        _id: appData.devices.filter((item) => item.name === e.target.value)[0]
          ._id,
      };
    }
    setCloneTempFields(tempSelected);
    setErrorMsg(false);
    // setHelperText("");
  };

  const fetchMarket = () => {
    getMarketDetails(async (response, err, errCode) => {
      if (err) {
      } else {
        // const data = response.data;
        const countriesList = await response.data;

        let marketData = [];
        countriesList.forEach((item) => marketData.push(item.name));
        setMarketDataList(response.data);
        setMarket(marketData);
        getMarketname(response.data);
      }
    });
  };

  const existingSharedFromSource =async (sourceDeckId, target)=>{
        if(sourceDeckId){
            const payload={deckId : target , templateId : sourceDeckId};
            await getSharedFileFromTemp(payload, async(response, err, ErrorCode) => {
                if (err) { } else {
                  // console.log('=======response=======', response)
                  const data = await response;
                  return;
                 }
             })
        }
    }

  const cloneTemplate = async() => {
    // let format = /[`!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?~]/;
    // if (format.test(cloneTempFields?.name) === false) {
  
    if (cloneTempFields?.name.trim() !== "") {
      if (/^\s/.test(cloneTempFields?.name) !== true) {
        if (cloneTempFields.name.length > 2) {
          if (cloneTempFields.name.length <= 100) {
            const templatePayload = {
              name: cloneTempFields?.name,
              brand: cloneTempFields?.brand,
              market: cloneTempFields?.market,
              //dimension: cloneTempFields?.dimension,
              //device: cloneTempFields?.device?._id,
              //campaign: cloneTempFields?.campaign,
              type: 1,
              docNumber: cloneTempFields?.docNumber,
              pinch_to_zoom: enablePinchToZoom
            };

            setIsloading(true);

            cloneTemplateApi(
              cloneTempdata[0]._id,
              templatePayload,
              async(response, err, errorCode) => {
                if (err) { 
                  if (errorCode === 400) {
                    if (err?.response.data.err.message.includes('same name')) {
                     
                    }else
                    showErrorToast(err?.response.data.err.message);
                  } else 
                  showErrorToast('Clone Template failed');
                  setIsloading(false);
                } else {
                  // console.log(response, err)
                  const returnedResponse = response.data?.response;
                  setIsloading(false);
                  appData.setEdetailName(returnedResponse?.name);
                  showSuccessToast('Clone Template Created');
                  const pageId = returnedResponse?.slides[0].slideid;
                  const cloneData = {
                    edetailId: returnedResponse?._id,
                    slides: [],
                  };
                  cloneData.slides.push({
                    slideid: returnedResponse?.slides[0].slideid,
                  });
                  appData.setDeckId(returnedResponse);

                  setOpenCloneTemplate(false);
                  setCloneTempFields(returnedResponse);
                  if(isChecked) {
                    setDeckIdCurrent(returnedResponse);
                    setIsOpenSharedModal(true);
                  } else {
                   await existingSharedFromSource(cloneTempdata[0]._id, returnedResponse?._id )
                    navigateToEditor(returnedResponse.slides[0].slideid, returnedResponse);
                  }
                }
                let type = createEdetail ? eDetail : template;
                //getEdetailList(type);
              }
            );
          } else {
            setOpenCloneTemplate(true);
            showErrorToast('Template name exceeded the maximum length');
          }
        } else {
          showErrorToast('Template name should be more than 2 characters');
        }
      } else {
        showErrorToast(`Template name can't start with spaces`);
      }
    } else {
     /*  setHelperText("Template name cannot be blank");
      setErrorMsg(true); */
    }
  };
  const navigateToEditor = (pageId, data) => {
    if (pageId) {
      navigate(`/editor/${pageId}`, { state: { data: data } });

      //appData.setDeckId(data);
    }
  };
  const getBrandname = () => {
    let result = brands.find((item) => item._id === cloneTempFields.brand);
    return result?.name;
  };
  const [marketName, setMarketName] = useState("");
  const getMarketname = (response = []) => {
    // if (market.length === 0) {
    //   fetchMarket();
    // }
    let result = response.find((item) => item?._id === cloneTempFields?.market);
    setMarketName(result?.name);
    //  return result?.name;
  };
  // const getCampaignname = () => {
  //   let result = campaign.find((item) =>  item._id === cloneTempFields.campaign);
  //   if(!result?.name){
  //       setCloneTempFields({
  //         ...cloneTempFields,
  //         campaign: result.name,
  //       });
  //   }
  // };
  const validateForm = () => {
    if (cloneTempFields.name?.trim().toLowerCase() === "shared") {
      return true;
    }
    if (cloneTempFields.name?.length > 2 && cloneTempFields.docNumber !== '' && cloneTempFields.name?.length <=30 && !errorMsg) {
      return false;
    }
    return true;
  };

  const filterdCampaign = () => {
    let campaignData = brands.filter(
      (item) => item._id == cloneTempFields.brand
    );
    //setCampaignData(campaignData[0].campaigns);
  };

  useEffect(() => {
    filterdCampaign();
    //  getMarketname();
  }, []);
  const handleMarketChange = (e, newValue) => {
    
    if (newValue) {
      setCloneTempFields({
        ...cloneTempFields,
        docNumber: newValue,
      });
      //setMarketName(newValue);
    }
  };

  const isCheckedHandler = () => {
    if(shouldDisableCheckbox) {
      return true;
    } else {
      return !isChecked;
    }
  }

  const templateListUI = (props, option, { selected }) => {
      const { key, ...optionProps } = props;
      return (
        <li {...props} className="dropdown-list-css">
          <span>{option.name || option}</span>
        </li>
      );
  };

  const getAllPromoMatsId = async () => {
    setIsloading(true)
    const query ={type:1, brand:getVeevaId('brand',cloneTempdata[0].brand), market:getVeevaId('market',cloneTempdata[0].market)}
    getPromomatsId(query, async(response, err, errCode) => {
      if (err) {
        setIsloading(false)
      } else {
        const data = await response.data;
        // console.log('doclist', response.data.response.docs);
        if (data.success) {
          setPromomatsId(data.response.docs)
          setIsloading(false)
        }
      }
    })
  }

  const getVeevaId = (IdFor, Id) => {
    const veevaID = IdFor === 'brand' ? brands.find(b => b?._id === Id)?.veevaid : marketDataListFetch.find(m => m?._id === Id)?.veevaid;
    return veevaID;
  }

  const validateName = async() => {
    if (cloneTempFields?.name?.trim().toLowerCase() === "shared") {
      setHelperText(`"shared" is a reserved name and cannot be used.`);
      setErrorMsg(true);
      setDisableBtn(true);
      return;
    }
      verifyDeckName(
        { name: cloneTempFields?.name },
        1,
        async(response, err, errorCode) => {
          if (err) {
          } else {
            const data = await response?.data;
            if (data.success) {
              setErrorMsg(false);
            } else {
              const errMsg = data?.err;
               setHelperText(errMsg);
              setErrorMsg(true);
            }
             
           
             
          }
        }
      );
    };
  
    const focusedHandler = () => {
      if (cloneTempFields?.name?.trim().length < 3 && cloneTempFields?.name?.trim().length > 30) {
        setErrorMsg(true);
      }
    };
  return (
    <>
      {" "}
      {isloading && (
        <CircularProgressBar
          isloading={isloading}
          setIsloading={setIsloading}
        />
      )}
      <Modal
        show={openCloneTemplate}
        onHide={closeCloneTemplateModal}
        dialogClassName="clone-template-forms"
      >
        <Modal.Body className="clone-template-forms-modal">
          <div className="d-flex create-template-main">
            <section className="create-template-left-section">
              <div className="create-template-left-section-content">
                              <h2 className="create-template-left-section-header">
                                METADATA INFORMATION
                              </h2>
                              <div className="create-template-source">
                                <h3 className="create-template-source-name">Source</h3>
                                <p className="create-template-source-content">PromoMats</p>
                              </div>
                              <div className="create-template-created-by">
                                <h3 className="create-template-created-by-name">
                                  Created by
                                </h3>
                                <p className="create-template-created-by-content">
                                  {userName}
                                </p>
                              </div>
                              <div className="create-template-created-on">
                                <h3 className="create-template-created-on-name">
                                  Created on
                                </h3>
                                <p className="create-template-created-on-content">
                                   {convertInDate(Date(), "normal")}
                                </p>
                              </div>
                              <div className="create-template-created-on">
                                <h3 className="create-template-created-on-name">Product</h3>
                  <p className="create-template-created-on-content">
      {getBrandname()}
                                </p>
                              </div>
                              <div className="create-template-created-on">
                                <h3 className="create-template-created-on-name">Country</h3>
                                <p className="create-template-created-on-content">
              
                                  {marketName}
                                </p>
                              </div>
                            </div>
            </section>
            <section className="create-template-right-section">
              <div className="create-template-right-section-content">
                <div>
                  <TextField
                    className="create-template-input-field clone-template-field"
                    size="small"
                    variant="outlined"
                    label="Template Name"
                    name="name"
                    fullWidth={true}
                    value={cloneTempFields?.name}
                    onChange={(e) => {
                      handleChangeCloneTemplates(e, "name");
                    }}
                    required
                    autoComplete="off"
                    style={{
                      fontSize: "12px",
                      transformOrigin: "top",
                      color: "#66676b",
                      marginTop: "4px"
                    }}
                    helperText={helperText}
                    error={errorMsg}
                    onBlur={() => {
                    focusedHandler();
                    validateName();
                  }}
                  ></TextField>
                </div>
                {/* <div style={{marginTop: "16px"}}>
                  <TextField
                    className="clone-template-brand-field"
                    size="small"
                    variant="outlined"
                    label="Product "
                    name="brand"
                    required
                    fullWidth={true}
                    value={getBrandname()}
                    disabled
                    autoComplete="off"
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      height: "42px",
                      
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        fontSize: "12px",
                        paddingTop: "7px",
                        color: "#66676b",
                      },
                    }}
                  ></TextField>
                </div> */}
                <div className="" style={{marginTop: "16px"}}>
                  {/* <Autocomplete
                    disableClearable
                    //popupIcon={<BackArrowicon />}
                    popupIcon={<img src={BackArrowicon} alt="" />}
                    id="combo-box-demo"
                    className="create-template-market-field"
                    options={market}
                    value={marketName}
                    //  onChange={(e) => handleChangeCloneTemplates(e, "market")}
                    onChange={(e, newValue) => handleMarketChange(e, newValue)}
                    fullWidth={true}
                    size="small"
                    sx={{
                      "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                        fontSize: "12px",
                        transformOrigin: "top",
                        color: "#66676b",
                      },
                    }}
                    style={{borderRadius: "0"}}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="market"
                        label={<span>Market <span className="required-field">*</span></span>}
                      />
                    )}
                  /> */}
                  <CommonAutocompleteDropdown
                    options={PromoMatsID.map(id=> id.docNumber)}
                      disableValue={
                        PromoMatsID.length < 1 && !isloading ? true : false
                      }
                      value={cloneTempFields?.docNumber}
                      label="Promomats Template Doc ID"
                      required={ PromoMatsID.length < 1 && !isloading ? false : true}
                      renderOption={templateListUI}
                      onChange={handleMarketChange}
                  />
                  {PromoMatsID.length < 1 && !isloading &&  (
                      <FormHelperText className="Helper-warning-message">
                        <img src={WarningIcon} width={12} height={12} />
                        <span>No Promomats ID found.</span>
                      </FormHelperText>
                    )}
                </div>
                <div className="one-time-content-option">
                  <div className="one-time-content-option-label">Pinch to Zoom
                    <CustomTooltip title={`Allows users to zoom in and out using two‑finger pinch gestures on the screen.`} placement="bottom-start">
                      <span className="pinch-to-zoom-tool-tip">i</span>
                    </CustomTooltip>
                  </div>
                  <div className={`one-time-content-option-toggle ${enablePinchToZoom ? 'active' : 'disabled'}`} onClick={() => setEnablePinchToZoom(previousValue => !previousValue)}>
                    <div className="toggle-thumb"></div>
                  </div>
                </div>
                {/* <div style={{marginTop: "16px"}}>
                  <FormControl
                      fullWidth
                      size="small"
                      className="create-template-dropdown-field searchFieldlabel campaignfield"
                    >
                    <InputLabel
                      id="demo-simple-select-label"
                      required
                      className="create-template-dropdown-label"
                      style={{
                        fontSize: "12px",
                        transformOrigin: "top",
                        color: "#66676b",
                        position: "absolute",
                      }}
                    >
                      Campaign
                    </InputLabel>
                    <Select
                      // IconComponent={iconComponent}
                      labelId="demo-select-small"
                      id="demo-select-small"
                      value={cloneTempFields.campaign}
                      label="Campaign"
                      onChange={(e) => handleChangeCloneTemplates(e, "campaign")}
                      name="campaign"
                      style={{
                        fontSize: "12px",
                        color: "#231f20",
                        fontWeight: "600",
                        padding: "5px 0 0 0",
                        letterSpacing: "0.12px",
                      }}
                      className="create-template-dropdown-list"
                    >
                      {compaignData &&
                        compaignData.length > 0 &&
                        compaignData.map((item) => {
                          return (
                            <MenuItem value={item?._id} id={item._id} key={item._id}>
                              {item?.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div> */}
                {/* <div className="d-flex add-shared-resources" style={{marginTop: '14px', marginBottom: "16px"}}>
                  <input
                    type="checkbox"
                    className="create-template-checkbox"
                    name="shared_toggle"
                    checked={isChecked}
                    disabled={shouldDisableCheckbox}
                    onChange={handleCheckboxChange}
                  />
                  <p>Add Shared Resources</p>
                </div> */}
              </div>
            </section>
          </div>
        </Modal.Body>
        <Modal.Footer className="clone-template-footer-section">
          <Button
            className="cancel-clone-template"
            type="button"
            onClick={closeCloneTemplateModal}
          >
            CANCEL
          </Button>
          <Button
            className={`create-template-next-btn ${disableBtn && validateForm() ? "disabled-template-btn" : "enabled-template-btn"}`}
            type="button"
            // style={{ height: "40px" }}
            onClick={(e) =>errorMsg ?'': cloneTemplate(e)}
            disabled={disableBtn && validateForm()}
          >
            {isChecked ? "NEXT": "GO TO EDITOR"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
